import { DEFAULT_RESPONSE_TIMEOUT } from 'constants/server';

export const SET_TAG_WAIT_TIMEOUT = DEFAULT_RESPONSE_TIMEOUT; // 15s server timeout + 5s AA treshhold
